.root {
  display: flex;
  flex-wrap: wrap;
  gap: 3.2rem;
  align-items: baseline;
  justify-content: center;
  min-width: 30rem;
  padding: 3.2rem;
  background: var(--gradient-ziggurat-to-edgewater);
  border-radius: 2.4rem;
}
